const CornerUpRight = ({color = '#27323C'}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15 14L20 9L15 4" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4 20V13C4 11.9391 4.42143 10.9217 5.17157 10.1716C5.92172 9.42143 6.93913 9 8 9H20" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  );
};

export default CornerUpRight;